export enum CustomerEmployeeSortType {
    Id,
    FullName,
    IsDeleted,
    PersonalPicture
}
